import * as React from 'react';
import { connect } from 'react-redux';
import { Modal, Button } from 'react-bootstrap';
import assign from 'object-assign';
import notify from '../../../shared/feedback/notifications';
import { Translate } from '../../../shared/LanguageService';
import * as RegionActions from '../actions/RegionActions';
import RegionForm from '../RegionForm';
import { handleError } from '../../../shared/ErrorCatching';

class EditRegionModal extends React.Component<any, any> {
    constructor(props: any, context: any) {
        super(props, context);
        this.state = {
            region: {},
            errors: {},
            editing: false
        };

        this.onChange = this.onChange.bind(this);
        this.edit = this.edit.bind(this);
        this.formIsValid = this.formIsValid.bind(this);
    }

    UNSAFE_componentWillMount() {
        this.props.actions
            .editRegion(this.props.regionId)
            .then(() => {
                this.setState({ region: assign({}, this.props.region) });
            })
            .catch((errorResponse: any) => handleError(errorResponse));
    }

    render() {
        return (
            <div>
                <Modal show={true} onHide={this.props.closeModal}>
                    <Modal.Header closeButton>
                        <Modal.Title>
                            {Translate('edit-region/modal/title/create-region')}
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <RegionForm
                            errors={this.state.errors}
                            region={this.state.region}
                            displayIsDiscontinued={true}
                            onChange={this.onChange}
                        />
                    </Modal.Body>
                    <Modal.Footer>
                        <Button onClick={this.props.closeModal}>
                            {Translate('edit-region/modal/footer/button-label/close')}
                        </Button>
                        <Button
                            disabled={this.state.editing || !this.formIsValid()}
                            bsStyle="primary"
                            onClick={this.edit}
                        >
                            {Translate('edit-region/modal/footer/button-label/save')}
                        </Button>
                    </Modal.Footer>
                </Modal>
            </div>
        );
    }

    edit() {
        this.setState({ editing: true });
        this.props.actions
            .updateRegion(this.state.region)
            .then(() => {
                notify.success(Translate('edit-region/notification/region-updated'));
                this.setState({ editing: false });
                this.props.closeModal();
            })
            .catch((errorResponse: any) =>
                handleError(errorResponse, (errors) => {
                    this.setState({ errors: errors, editing: false });
                })
            );
    }

    formIsValid() {
        return this.state.region.name && this.state.region.name.length > 0;
    }

    onChange(region: any) {
        this.setState({ region: region });
    }
}

function mapStateToProps(state: any, ownProps: any) {
    return {
        region: state.regions.edit
    };
}

function mapDispatchToProps(dispatch: any) {
    return {
        actions: {
            editRegion: (id: number) => dispatch(RegionActions.editRegion(id)),
            updateRegion: (region: any) => dispatch(RegionActions.updateRegion(region))
        }
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(EditRegionModal);
